var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',{attrs:{"type":_vm.renderTag(_vm.title),"dot":_vm.dot}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }